module.exports = __webpack_public_path__ + "static/projects-b2faec0a98204979bf51ce8a53620f1c.svg";